import { TabNames } from '@enums/TabNames';
import { IRouterNavigationConfig } from '@shared/grids/grid.config';
import { ColDef, ICellRendererParams } from 'ag-grid-enterprise';

export const CONTACTS_ROUTER_CONFIG: IRouterNavigationConfig = {
    base: '/contacts-single',
    idKey: 'id',
    extra: [TabNames[TabNames.Overview]]
};

export const CONTACTS_GRID_COLUMNS: ColDef[] = [
    {
        colId: 'id',
        field: 'id',
        headerName: 'ID',
        width: 100,
        lockPinned: true,
        lockPosition: 'left',
        suppressSizeToFit: true,
        cellRenderer: (params: ICellRendererParams) => {
            if (params.value) {
                const link = `/contacts-single/${params.value}/${TabNames[TabNames.Overview]}`;
                return `<a class="anchor" href="${link}">${params.value}</a>`;
            }
            return '';
        }
    },
    {
        colId: 'firstName',
        field: 'firstName',
        headerName: 'First Name',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor'
    },
    {
        colId: 'lastName',
        field: 'lastName',
        headerName: 'Last Name',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor'
    },
    {
        colId: 'phone',
        field: 'phone',
        headerName: 'Phone',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor',
        sortable: false
    },
    {
        colId: 'email',
        field: 'email',
        headerName: 'Email',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor',
        sortable: false
    },
    {
        colId: 'companyName',
        field: 'companyName',
        headerName: 'Company',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor'
    },
    {
        colId: 'isActive',
        field: 'isActive',
        headerName: 'Condition',
        valueFormatter: (params: any) => {
            return params.value ? 'Active' : 'Archived';
        }
    }
];
